import React from 'react';
import { MapPin, Globe } from 'lucide-react';

const GlobalPresence = () => {
  const locations = [
    { city: "Hyderabad", country: "India", region: "Asia" },
    { city: "Mumbai", country: "India", region: "Asia" },
    { city: "Chennai", country: "India", region: "Asia" },
    { city: "Paris", country: "France", region: "Europe" },
    { city: "Zagreb", country: "Croatia", region: "Europe" },
    { city: "Riyadh", country: "Saudi Arabia", region: "Middle East" },
    { city: "Dallas", country: "USA", region: "North America" },
    { city: "Dubai", country: "UAE", region: "Middle East" }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-[#0077cc] rounded-full text-sm font-medium mb-4">
            <Globe size={16} />
            Worldwide Network
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Global <span className="text-[#0077cc]">Presence</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Operating across 160+ countries, connecting content with audiences worldwide
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Location Cards Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
            {locations.map((location, index) => (
              <div
                key={index}
                className="group p-5 rounded-2xl border bg-white border-gray-100 hover:border-[#0077cc] hover:shadow-lg transition-all duration-300 text-center"
                data-testid={`location-${location.city.toLowerCase()}`}
              >
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br from-[#0077cc] to-[#00c6d7] flex items-center justify-center group-hover:scale-110 transition-transform">
                  <MapPin className="text-white" size={22} />
                </div>
                <div className="font-bold text-lg text-gray-900 mb-1">
                  {location.city}
                </div>
                <div className="text-sm text-[#0077cc] font-medium">
                  {location.country}
                </div>
                <div className="text-xs text-gray-400 mt-1">
                  {location.region}
                </div>
              </div>
            ))}
          </div>

          {/* Global Stats */}
          <div className="grid grid-cols-3 gap-3 md:gap-4 mt-8">
            <div className="p-4 bg-white rounded-xl border border-gray-200 text-center hover:border-[#0077cc] hover:shadow-md transition-all">
              <div className="text-2xl md:text-3xl font-bold text-[#0077cc]">160+</div>
              <div className="text-xs md:text-sm text-gray-500 mt-1">Countries Reached</div>
            </div>
            <div className="p-4 bg-white rounded-xl border border-gray-200 text-center hover:border-[#0077cc] hover:shadow-md transition-all">
              <div className="text-2xl md:text-3xl font-bold text-[#0077cc]">8</div>
              <div className="text-xs md:text-sm text-gray-500 mt-1">Office Locations</div>
            </div>
            <div className="p-4 bg-white rounded-xl border border-gray-200 text-center hover:border-[#0077cc] hover:shadow-md transition-all">
              <div className="text-2xl md:text-3xl font-bold text-[#0077cc]">100+</div>
              <div className="text-xs md:text-sm text-gray-500 mt-1">Languages</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;
